export default "__VITE_ASSET__CKV91rms__"